import { render, staticRenderFns } from "./paso1.vue?vue&type=template&id=75498502&scoped=true&"
import script from "./paso1.vue?vue&type=script&lang=ts&"
export * from "./paso1.vue?vue&type=script&lang=ts&"
import style0 from "./paso1.vue?vue&type=style&index=0&id=75498502&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75498502",
  null
  
)

export default component.exports